// European airports data for Crisis Command
// Pixel coordinates calculated using calibrated projection (1920×1080)
// Auto-generated by generate_europe_map.py - DO NOT EDIT MANUALLY
export const AIRPORTS = [
  { iata: 'AMS', name: 'Amsterdam Schiphol', lat: 52.309, lon: 4.764, px: 723.83, py: 496.3 },
  { iata: 'ARN', name: 'Stockholm Arlanda', lat: 59.651, lon: 17.919, px: 1083.67, py: 296.22 },
  { iata: 'ATH', name: 'Athens', lat: 37.936, lon: 23.944, px: 1248.48, py: 887.99 },
  { iata: 'BCN', name: 'Barcelona El Prat', lat: 41.297, lon: 2.078, px: 650.35, py: 796.4 },
  { iata: 'BER', name: 'Berlin Brandenburg', lat: 52.362, lon: 13.501, px: 962.82, py: 494.86 },
  { iata: 'BRU', name: 'Brussels', lat: 50.901, lon: 4.484, px: 716.17, py: 534.67 },
  { iata: 'BUD', name: 'Budapest', lat: 47.436, lon: 19.255, px: 1120.22, py: 629.1 },
  { iata: 'CDG', name: 'Paris Charles de Gaulle', lat: 49.009, lon: 2.547, px: 663.18, py: 586.23 },
  { iata: 'CPH', name: 'Copenhagen', lat: 55.618, lon: 12.656, px: 939.71, py: 406.13 },
  { iata: 'DUB', name: 'Dublin', lat: 53.421, lon: -6.27, px: 422.0, py: 466.0 },
  { iata: 'FCO', name: 'Rome Fiumicino', lat: 41.8, lon: 12.238, px: 928.27, py: 782.69 },
  { iata: 'FRA', name: 'Frankfurt', lat: 50.037, lon: 8.562, px: 827.72, py: 558.22 },
  { iata: 'HEL', name: 'Helsinki', lat: 60.317, lon: 24.963, px: 1276.35, py: 278.07 },
  { iata: 'IST', name: 'Istanbul', lat: 41.275, lon: 28.752, px: 1380.0, py: 797.0 },
  { iata: 'LGW', name: 'London Gatwick', lat: 51.153, lon: -0.182, px: 588.53, py: 527.81 },
  { iata: 'LHR', name: 'London Heathrow', lat: 51.47, lon: -0.454, px: 581.09, py: 519.17 },
  { iata: 'LIN', name: 'Milan Linate', lat: 45.445, lon: 9.276, px: 847.25, py: 683.36 },
  { iata: 'LIS', name: 'Lisbon', lat: 38.781, lon: -9.136, px: 343.6, py: 864.97 },
  { iata: 'MAD', name: 'Madrid Barajas', lat: 40.472, lon: -3.561, px: 496.1, py: 818.88 },
  { iata: 'MUC', name: 'Munich', lat: 48.353, lon: 11.786, px: 915.91, py: 604.11 },
  { iata: 'MXP', name: 'Milan Malpensa', lat: 45.63, lon: 8.723, px: 832.12, py: 678.32 },
  { iata: 'NCE', name: 'Nice', lat: 43.658, lon: 7.216, px: 790.9, py: 732.06 },
  { iata: 'ORY', name: 'Paris Orly', lat: 48.726, lon: 2.365, px: 658.2, py: 593.95 },
  { iata: 'OSL', name: 'Oslo', lat: 60.193, lon: 11.1, px: 897.14, py: 281.45 },
  { iata: 'PRG', name: 'Prague', lat: 50.1, lon: 14.26, px: 983.58, py: 556.5 },
  { iata: 'VIE', name: 'Vienna', lat: 48.11, lon: 16.57, px: 1046.77, py: 610.73 },
  { iata: 'VLC', name: 'Valencia', lat: 39.489, lon: -0.482, px: 580.33, py: 845.67 },
  { iata: 'WAW', name: 'Warsaw', lat: 52.165, lon: 20.967, px: 1167.05, py: 500.23 },
  { iata: 'ZRH', name: 'Zurich', lat: 47.458, lon: 8.555, px: 827.53, py: 628.5 },
];

// Map bounding box - calculated from actual pixel positions on the map image
export const MAP_BOUNDS = {
  latMin: 30.890353,
  latMax: 70.520807,
  lonMin: -21.697228,
  lonMax: 48.493002
};

// Project lat/lon to pixel coordinates
export const projectToPixel = (lat, lon, width, height) => {
  const { latMin, latMax, lonMin, lonMax } = MAP_BOUNDS;

  const xNorm = (lon - lonMin) / (lonMax - lonMin);
  const yNorm = 1 - (lat - latMin) / (latMax - latMin);

  return {
    x: xNorm * width,
    y: yNorm * height
  };
};

// Find airport by IATA code
export const findAirport = (iata) => {
  return AIRPORTS.find(a => a.iata === iata);
};
